<template lang="pug">
.analise
  app-relatorio-base(
    titulo="DAEs por município",
    :filtro="filtro",
    :municipios="municipios"
    :receitas="receitas"
    @gerarGraficos="updateDados",
    @tabChange="updateDados"
    :valorTotal="formatTotal(total)"
    :selecionarTodosMunicipios="true"
    :selecionarTodasReceitas="true"
    @atualizarSelecionarTodosMunicipios="atualizarSelecionarTodosMunicipios"
  )
      el-row(slot="grafico").contentCardGrafico
        dae-municipio(v-if="daesMunicipios.length > 0" :dadosDb="daesMunicipios")
        p.empty-div(v-else) Nenhum dado encontrado.
      el-row(slot="tabela").contentCard
        div
          el-table.table-div(
            :data="daesMunicipios.content",
            empty-text="Nenhum dado encontrado."
          )
            el-table-column(
              label='Município'
              prop="label"
              sortable
            )
            el-table-column(
              label="Recebido"
              align="right"
            )
              template(slot-scope="scope")
                span R$ {{ scope.row.quitado | formatDouble }}
            el-table-column(
              label="Vencido"
              align="right"
            )
              template(slot-scope="scope")
                span R$ {{ scope.row.vencido | formatDouble }}
            el-table-column(
              label="Aguardando Pagamento"
              align="right"
            )
              template(slot-scope="scope")
                span R$ {{ scope.row.aguardandoPagamento | formatDouble }}
            el-table-column(
              label="Emitido"
              align="right"
            )
              template(slot-scope="scope")
                span R$ {{ scope.row.emitido | formatDouble }}
          .paginacao(slot="pagination")
            p.label-total
              b Valor total:
              | &nbsp {{ formatTotal(total) }}
            app-paginacao(
              :total="daesMunicipios.totalElements",
              :pagina="filtro.pagina",
              @changePage="changePage"
            )
            el-row.button-row
              el-button(
                type="default",
                size="small"
                @click="exportarCsvDaeMunicipio()"
              )
                i.fal.fa-file-csv
                span &nbsp Exportar CSV

</template>

<script>
import AppRelatorioBase from '@/screens/financeiro/relatoriosDae/components/AppRelatorioBase.vue'
import DaeTotais from '@/screens/financeiro/relatoriosDae/components/DaeTotais.vue'
import DaeMunicipio from '@/screens/financeiro/relatoriosDae/components/DaeMunicipio.vue'
import AppPaginacao from '@/components/AppPaginacao'
import { mapActions } from 'vuex'
import utils from '@/utils/utils'

export default {
  components: {
    AppRelatorioBase,
    DaeTotais,
    DaeMunicipio,
    AppPaginacao
  },

  data () {
    return {
      daesMunicipios: [],
      filtro: {
        dataInicio: null,
        pagina: 1,
        dataFim: null,
        municipios: this.municipios,
        receitas: this.receitas
      },
      total: 0
    }
  },

  props: {
    municipios: {
      type: Array,
      required: true
    },
    receitas: {
      type: Array,
      required: true
    }
  },

  created () {
    this.updateDados('GRAFICO')
  },

  methods: {
    ...mapActions({
      getDaesMunicipio: 'relatoriosDae/getDaesMunicipio',
      getDaesMunicipioPaginado: 'relatoriosDae/getDaesMunicipioPaginado',
      getTotalDaesMunicipio: 'relatoriosDae/getTotalDaes',
      getCSVDaesByMunicipio: 'relatoriosDae/getCSVDaesByMunicipio'
    }),

    async updateDados (tab) {
      await this.search(tab, {
        ...this.filtro,
        pagina: this.filtro.pagina - 1,
        dataInicio: this.filtro.dateRange ? this.filtro.dateRange[0] : null,
        dataFim: this.filtro.dateRange ? this.filtro.dateRange[1] : null,
        municipios: this.filtro.municipios.map(item => item.id),
        tiposReceita: this.filtro.receitas.map(item => item.codigo)
      })
    },

    async search (tab, filtro) {
      this.daesMunicipios = tab === 'GRAFICO' ? await this.getDaesMunicipio(filtro) : await this.getDaesMunicipioPaginado(filtro)

      this.total = this.setTotal(this.daesMunicipios)
    },

    atualizarSelecionarTodosMunicipios () {

    },

    changePage (newPage) {
      this.filtro.pagina = newPage
      this.updateDados('pagina')
    },

    setTotal (daes) {
      let total = 0
      daes.forEach(element => {
        total = total + element.emitido
      })
      return total
    },

    formatTotal (valor) {
      return utils.padraoMoedaBrasil.format(valor)
    },

    // Exportar csv com os DAE sobre filtro aplicado
    async exportarCsvDaeMunicipio () {
      const filtro = {
        ...this.filtro,
        dataInicio: this.filtro.dateRange ? this.filtro.dateRange[0] : null,
        dataFim: this.filtro.dateRange ? this.filtro.dateRange[1] : null,
        municipios: this.filtro.municipios.map(item => item.id),
        receitas: this.filtro.receitas.map(item => item.codigo),
        receitasDescricoes: this.filtro.receitas.map(item => item.descricao)
      }

      await this.getCSVDaesByMunicipio(filtro)
    }
  }
}
</script>

<style lang="scss" scoped>
.tituloGraficos {
  font-size: 25px;
}

.contentCardGrafico {
  height: auto;
}

.contentCard {
  height: auto;
  display: contents;
}

.table-div {
  min-height: 320px;
  font-size: 14px;
}

.empty-div {
  text-align: center;
  padding: 20px;
}

.paginacao {
  display: flex;
  justify-content: space-between;
}

@media (min-width: 600px) and (max-width: 1460px) {
  .contentCard {
    height: 470px;
  }
}

.button-row {
  margin-top: 18px;
}

.label-total {
  margin-top: 18px !important;
  font-size: 14px
}

</style>



// WEBPACK FOOTER //
// src/screens/financeiro/relatoriosDae/DaesMunicipio.vue